"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync } from "vue-property-decorator";
import { ControllerComponent } from "@/components/core";
import ItemLauncherShops from "./dialogs/ItemLauncherShops.vue";
import API from "@ym-framework/api-utils";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
export class Controller {
}
let ItemLauncher = class extends ControllerComponent {
  // @Debounce(600)
  runtime(item) {
    return __async(this, null, function* () {
      try {
        this._item.runtime.status = "loading";
        try {
          yield API.get(`api://base.local/storages/preference/mainExtensionVersion`);
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.launcher_new",
            value: {
              shop_id: item.oldId,
              vd_id: this._item.oldId,
              new_vd: this._item.id,
              new_shop_id: item.id
            }
          });
        } catch (error) {
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.launcher",
            value: {
              shop_id: item.oldId,
              vd_id: this._item.oldId,
              new_vd: this._item.id,
              new_shop_id: item.id
            }
          });
        }
      } catch (error) {
      }
    });
  }
  checkVersion(item) {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        if (_version === "6.8.2.7") {
          let realVersion = version_response.data.os.version.split("(")[0].trim();
          if (realVersion === "0" || realVersion === "7") {
            let response = yield API.get(`api://base.auth/api/v9/shop/${item.oldId}/browser_core`);
            if (response.data.code === "chrome" && response.data.version === "122") {
              try {
                try {
                  yield API.get(`api://base.local/storages/session/checkOpenWin7`);
                } catch (error) {
                  yield UiConfirm.warnconfirm(`${this.$t("main.win7_tips_message")}`, this.$t("main.win7_tips_title"), {
                    confirmButtonText: this.$t("main.win7_tips_confirm"),
                    customClass: "new-confirm-box",
                    showClose: false,
                    cancelButtonText: this.$t("headertoolbar.cancel")
                  });
                }
                yield API.put(`api://base.local/storages/session/checkOpenWin7`, {
                  "message": "no.show.win7",
                  "model": "no.show.win7"
                });
                try {
                  yield API.post(`api://base.auth/api/v9/shop/${item.oldId}/browser_core_auto_downgrade`);
                } catch (error) {
                  return false;
                }
                return false;
              } catch (error) {
                return true;
              }
            }
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    });
  }
  // 打开添加店铺弹窗
  openCreateShop() {
    this.$emit("bindshop");
  }
  // 获取流量超限
  getFlowOverRange() {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.auth.pro/v1/virtual-desktops/flow_overranges`);
      for (let data of response.data.datas) {
        if (data.ip === this._item.ip) {
        }
      }
    });
  }
  launcher() {
    return __async(this, null, function* () {
      if (this._item.marks.is("FLOW_OVER_RANGE")) {
        try {
          yield UiConfirm.warnconfirm(this.$t("over_flow_dialog.tips"), this.$t("over_flow_dialog.title"), {
            confirmButtonText: this.$t("over_flow_dialog.confirm"),
            showClose: false,
            customClass: "new-confirm-box"
          });
        } catch (error) {
          if (error === "cancel") {
            return;
          }
        }
      }
      const _itemLauncherShops = ItemLauncherShops.create(this._item);
      if (this._item.shops.length > 1) {
        _itemLauncherShops.show();
      }
      if (this._item.shops.length === 1) {
        const flag = yield this.checkVersion(this._item.shops[0]);
        if (flag === true) {
          return;
        }
        this.runtime(this._item.shops[0]);
      }
      _itemLauncherShops.$on("launcher", (item) => __async(this, null, function* () {
        const flag = yield this.checkVersion(item);
        if (flag === true) {
          return;
        }
        this.runtime(item);
        _itemLauncherShops.$nextTick(() => {
          _itemLauncherShops.close();
        });
      }));
    });
  }
  launcherRenew() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(this._item.oldId);
        let response = yield API.post(
          `api://base.auth/api/v7/payment/virtualdesktop-verification/renew`,
          {
            ids: arr
          }
        );
        this.$router.push({
          name: "payment",
          query: {
            style: "renew"
          },
          params: {
            item: JSON.stringify(this._item)
          }
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  remote_launcher() {
    return __async(this, null, function* () {
      this.$emit("remoteLauncher");
    });
  }
};
__decorateClass([
  PropSync("item")
], ItemLauncher.prototype, "_item", 2);
ItemLauncher = __decorateClass([
  Component({})
], ItemLauncher);
export {
  ItemLauncher as default
};
